import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { CalendarClock, MessageCircle, X } from "lucide-react";

const WA_ADMIN = "6285261925686";

// Site-wide reminder shown to a logged-in NON-admin user when their annual-fee
// license is within 14 days of expiry (or already expired). Expired = not dismissable.
export default function LicenseBanner() {
  const { user, isAdmin } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  if (!user || isAdmin) return null;
  const d = user.license_days_left;
  if (d == null || d > 14) return null;

  const expired = d < 0 || user.license_expired;
  if (dismissed && !expired) return null;

  const label = expired
    ? `Lisensi Anda sudah habis${user.license_expires_at ? ` pada ${user.license_expires_at}` : ""}. Perpanjang untuk terus memakai fitur.`
    : d === 0
      ? `Lisensi Anda habis HARI INI (${user.license_expires_at}). Segera perpanjang.`
      : `Lisensi Anda habis dalam ${d} hari (${user.license_expires_at}). Segera perpanjang.`;

  const msg = `Halo Admin TRMD Performance, ${expired ? "lisensi saya sudah habis" : `lisensi saya habis dalam ${d} hari`} (${user.license_expires_at || "-"}). Saya mau perpanjang. Nama: ${user.name || "-"}, Email: ${user.email || "-"}, No HP: ${user.phone || "-"}`;
  const wa = `https://wa.me/${WA_ADMIN}?text=${encodeURIComponent(msg)}`;

  return (
    <div
      data-testid="license-reminder-banner"
      className={`flex items-center gap-3 px-4 py-2.5 text-sm border-b ${
        expired
          ? "bg-red-950/50 border-red-800/50 text-red-200"
          : "bg-amber-950/40 border-amber-800/40 text-amber-200"
      }`}
    >
      <CalendarClock className="h-4 w-4 shrink-0" />
      <span className="flex-1 min-w-0">{label}</span>
      <a
        href={wa}
        target="_blank"
        rel="noreferrer"
        data-testid="license-banner-renew-btn"
        className="shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[#25D366] hover:bg-[#20bd5a] text-slate-950 font-bold text-xs transition-colors"
      >
        <MessageCircle className="h-4 w-4" /> Perpanjang
      </a>
      {!expired && (
        <button
          data-testid="license-banner-dismiss"
          onClick={() => setDismissed(true)}
          className="shrink-0 p-1 rounded text-amber-300/70 hover:text-amber-100"
          title="Tutup"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
